// AI Chat helpers. A request id identifies ONE user intent: reuse it when retrying the same text so the server can never charge twice.
export const MAX_TEXT = 8000;
export const newRequestId = (random = (typeof crypto !== "undefined" && crypto.randomUUID ? () => crypto.randomUUID() : () => `${Date.now()}-${Math.random().toString(36).slice(2)}`)) =>
  `r-${random()}`.replace(/[^A-Za-z0-9_-]/g, "-").slice(0, 64);

export const canSend = (text, busy) => !busy && typeof text === "string" && text.trim().length > 0 && text.length <= MAX_TEXT;

export const STATUS_TEXT = {
  done: "", pending: "Sedang diproses…", reconciling: "Hasil belum pasti. Kredit ditahan sampai diperiksa; jangan kirim ulang.",
  failed: "Gagal. Kredit dikembalikan.", rejected: "Tidak dikirim (kredit tidak cukup).",
};
export const messageStatusText = (status) => (status in STATUS_TEXT ? STATUS_TEXT[status] : "");
export const errorText = (error) => (typeof error?.response?.data?.detail === "string" ? error.response.data.detail : "Permintaan belum berhasil. Coba lagi.");
export const UNAVAILABLE_TEXT = "Chat AI belum tersedia. Kontrak model dan metering biaya masih dalam proses.";
